import React from 'react';
import { observer } from 'mobx-react';
import { makeStyles, createStyles } from '@material-ui/core/styles';
import { Parallax } from 'react-parallax';
import Button from '@material-ui/core/Button';
import Typography from '@material-ui/core/Typography';

import SignUpBtn from '~/components/auth/SignUpBtn';
import authStore from '~/stores/authStore';

const useStyles = makeStyles(({ spacing, palette }) =>
    createStyles({
        root: {
            height: 400,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-evenly',
            flexDirection: 'column',
            padding: spacing(10),
            '& > *': {
                margin: spacing(1, 0)
            }
        },
        text: {
            color: palette.primary.contrastText
        }
    })
);

const langLib = {
    en: {
        title: 'PRICING',
        price: '$0.003 per minute of audio',
        details: 'No monthly fees. Top up your balance — pay only for what you use.',
        signUp: 'Sign Up Now'
    },
    ru: {
        title: 'СТОИМОСТЬ',
        price: '0,19 ₽ за минуту аудио',
        details: 'Нет месячных подписок. Пополняйте баланс — платите только за использованные минуты.',
        signUp: 'Зарегистрироваться'
    }
} as const;

const SpeechParallax = () => {
    const { lang } = authStore;
    const lib = langLib[lang];
    const classes = useStyles();

    return (
        <Parallax blur={2} bgImage="/static/parallax.jpg" bgImageAlt="background" strength={1000}>
            <div className={classes.root}>
                <Typography variant="h4" className={classes.text} align="center">
                    {lib['title']}
                </Typography>
                <Typography variant="h5" className={classes.text} align="center">
                    {lib['price']}
                </Typography>
                <Typography className={classes.text} align="center">
                    {lib['details']}
                </Typography>
                <SignUpBtn>
                    <Button color="secondary" variant="contained" size="large">
                        {lib['signUp']}
                    </Button>
                </SignUpBtn>
            </div>
        </Parallax>
    );
};

export default observer(SpeechParallax);
